import { $type as __type, createQueryOperator } from "../../_predicates";
const $type = createQueryOperator(__type);
export {
  $type
};
